import { render, staticRenderFns } from "./AlumnoInicio.vue?vue&type=template&id=6f826597"
import script from "./AlumnoInicio.vue?vue&type=script&lang=js"
export * from "./AlumnoInicio.vue?vue&type=script&lang=js"
import style0 from "./AlumnoInicio.vue?vue&type=style&index=0&id=6f826597&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports